import { History, ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

const TAG_TONE = {
    Sauvegarde: "bg-emerald-100 text-emerald-800", Go: "bg-emerald-100 text-emerald-800",
    "Redressement Judiciaire": "bg-amber-100 text-amber-800",
    Liquidation: "bg-rose-100 text-rose-800", "No Go": "bg-rose-100 text-rose-800",
};
const eur = (v) => (v == null || Number.isNaN(Number(v)) ? "n/c" : `${Math.round(Number(v)).toLocaleString("fr-FR")} €`);

export default function RapportDoubleHistorique({ items, selectedId, onSelect }) {
    if (!items?.length) return null;
    const chrono = [...items].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
    return (
        <div data-testid="rapport-double-historique" className="rounded-xl border border-slate-200 bg-white shadow-sm">
            <div className="flex items-center gap-2 px-4 py-3 border-b border-border">
                <History className="h-4 w-4 text-primary" strokeWidth={1.75} />
                <h3 className="font-display text-lg text-foreground">Historique des générations</h3>
                <span className="ml-auto text-xs text-muted-foreground">{items.length} génération{items.length > 1 ? "s" : ""}</span>
            </div>
            <table className="w-full text-sm">
                <thead>
                    <tr className="text-left text-xs uppercase tracking-[0.14em] text-muted-foreground border-b border-border">
                        <th className="py-2 px-4 font-medium">Date</th>
                        <th className="py-2 px-2 font-medium">Tags de décision</th>
                        <th className="py-2 px-2 font-medium text-right">Cash burn</th>
                        <th className="py-2 px-2 font-medium">DCP estimée</th>
                        <th className="py-2 px-4 font-medium text-right">Passif exigible</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-border">
                    {chrono.map((it, i) => {
                        const prev = chrono[i - 1];
                        const changed = prev && JSON.stringify(prev.tags) !== JSON.stringify(it.tags);
                        return (
                            <tr key={it.session_id} data-testid={`historique-row-${it.session_id}`} onClick={() => onSelect(it.session_id)}
                                className={cn("cursor-pointer hover:bg-accent/40 transition-colors", selectedId === it.session_id && "bg-accent/60")}>
                                <td className="py-2.5 px-4 whitespace-nowrap">{new Date(it.created_at).toLocaleString("fr-FR", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })}</td>
                                <td className="py-2.5 px-2">
                                    <span className="flex flex-wrap items-center gap-1.5">
                                        {changed && <span data-testid={`historique-evolution-${it.session_id}`} className="inline-flex items-center gap-1 text-xs text-muted-foreground">{prev.tags.join("/") || "—"} <ArrowRight className="h-3 w-3" /></span>}
                                        {it.tags.length ? it.tags.map((t) => <span key={t} className={cn("rounded-full px-2 py-0.5 text-xs font-bold", TAG_TONE[t] || "bg-muted")}>[{t}]</span>) : <span className="text-xs text-muted-foreground">—</span>}
                                    </span>
                                </td>
                                <td className="py-2.5 px-2 text-right tabular-nums">{eur(it.cash_burn_mensuel)}</td>
                                <td className="py-2.5 px-2">{it.date_cessation_paiement_estimee || "n/c"}</td>
                                <td className="py-2.5 px-4 text-right tabular-nums">{eur(it.passif_exigible)}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}
